import { render, staticRenderFns } from "./voice-stats-general.vue?vue&type=template&id=0690ba7b&"
import script from "./voice-stats-general.vue?vue&type=script&lang=js&"
export * from "./voice-stats-general.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports